/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersremovedescription2Inputs */

const en_membersremovedescription2 = /** @type {(inputs: Membersremovedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They lose access to your members-only events right away.`)
};

const de_membersremovedescription2 = /** @type {(inputs: Membersremovedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Person sieht deine Events „Nur Mitglieder“ ab sofort nicht mehr.`)
};

/**
* | output |
* | --- |
* | "They lose access to your members-only events right away." |
*
* @param {Membersremovedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersremovedescription2 = /** @type {((inputs?: Membersremovedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersremovedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersremovedescription2(inputs)
	return de_membersremovedescription2(inputs)
});
export { membersremovedescription2 as "membersRemoveDescription" }